import Model from "@/models/Model";
import CompanySimple from "@/models/company/CompanySimple";

export default class OrderSimple extends Model {

	public name!: string;
	public dateFrom!: string | null;
	public dateTo!: string | null;
	public company!: CompanySimple;

	public static isDateWithinRange(order: OrderSimple, date: Date | string): boolean {
		const d: Date = date instanceof Date ? date : new Date(date);

		if (order.dateFrom !== null) {
			const dFrom = new Date(order.dateFrom);
			if (d < dFrom) {
				return false;
			}
		}
		if (order.dateTo !== null) {
			const dTo = new Date(order.dateTo);
			if (d > dTo) {
				return false;
			}
		}

		return true;
	}

}
